import axios from 'axios';

const API_BASE_URL = 'https://apipublic.menuoff.com';

// Check if user is authenticated (session-based, with cookies only)
export const checkAuth = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/me`, {
      withCredentials: true,
    });
    return response.data.authenticated;
  } catch (error) {
    console.error('Auth check failed:', error);
    return false;
  }
};

// Get current user info (session-based)
export const getCurrentUser = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/me`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error('Get user failed:', error);
    return null;
  }
};

// Make authenticated API call (session-based)
export const authenticatedRequest = async (method, url, data = null, headers = {}) => {
  try {
    const config = {
      method,
      url: `${API_BASE_URL}${url}`,
      withCredentials: true,
      headers: {
        ...headers,
      }
    };
    if (data) {
      config.data = data;
    }
    const response = await axios(config);
    return response;
  } catch (error) {
    console.error('Authenticated request failed:', error);
    throw error;
  }
};